/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import OrgConstants from 'constants/OrgConstants'
import UserConstants from 'constants/UserConstants'

const OrgStore = Marty.createStore({
  id: 'OrgStore',

  getInitialState() {
    return {
      orgsById: {},
      resendInvitationState: {},
      orgUpdateState: {},
      billingState: null
    }
  },

  handlers: {
    handleOrgCreateDone: OrgConstants.ORG_CREATE_DONE,
    handleOrgFetchDone: OrgConstants.ORG_FETCH_DONE,

    handleOrgUpdateStarting: OrgConstants.ORG_UPDATE_STARTING,
    handleOrgUpdateDone: OrgConstants.ORG_UPDATE_DONE,

    shareEmailSnippet: OrgConstants.SHARE_SNIPPET,
    shareEmailSnippetDone: OrgConstants.SHARE_SNIPPET_DONE,

    // fetch current org as soon as current user available
    getOrFetchCurrentOrg: UserConstants.FETCH_CURRENT_USER_DONE,
  },

  setOrg(org) {
    const orgsById = _.cloneDeep(this.state.orgsById)
    orgsById[org.id] = org
    this.setState({ orgsById })
  },

  handleOrgCreateDone(org) {
    return this.setOrg(org)
  },

  handleOrgFetchDone(org) {
    return this.setOrg(org)
  },

  handleOrgUpdateStarting(orgId) {
    this.state.orgUpdateState[orgId] = OrgConstants.ORG_UPDATE_STARTING
    return this.setState({
      orgUpdateState: this.state.orgUpdateState
    })
  },

  handleOrgUpdateDone(orgId, org) {
    this.state.orgUpdateState[orgId] = OrgConstants.ORG_UPDATE_DONE
    this.setState({
      orgUpdateState: this.state.orgUpdateState
    })
    return this.setOrg(org)
  },

  getOrgUpdateState() {
    return this.state.orgUpdateState
  },

  shareEmailSnippet(email, orgId) {
    this.setState({ invitationState: OrgConstants.SHARE_SNIPPET_STARTING })
    return this.app.queries.OrgQueries.shareSnippet(email, orgId)
  },

  shareEmailSnippetDone(email, orgId) {
    // TODO remove when new-user pushes invited users
    // if the emails has just been invited, we need to refresh the userStore to include them
    this.app.queries.UserQueries.fetchUsersForOrgId(orgId)
    return this.setState({ invitationState: OrgConstants.SHARE_SNIPPET_DONE })
  },

  getInvitationState() {
    return this.state.invitationState
  },

  getResendInvitationState() {
    return this.state.resendInvitationState
  },

  resetResendInvitationState() {
    return this.setState({ resendInvitationState: {}})
  },

  getOrFetchCurrentOrg() {
    return this.fetch({
      id: 'getOrFetchCurrentOrg',
      dependsOn: [this.app.stores.UserStore.getOrFetchCurrentUser()],
      locally() {
        return this.state.orgsById[this.app.stores.UserStore.getCurrentUser().orgId]
      },
      remotely() {
        return this.app.queries.OrgQueries.fetchOrgById(this.app.stores.UserStore.getCurrentUser().orgId)
      }
    })
  },

  getCurrentOrg() {
    if (!this.app.stores.UserStore.getCurrentUser()) { return }
    return this.state.orgsById[this.app.stores.UserStore.getCurrentUser().orgId]
  },
})

export default OrgStore



// WEBPACK FOOTER //
// ./src/scripts/stores/OrgStore.js